import { driver } from 'driver.js';
import '../main.css';
import 'driver.js/dist/driver.css';
import { toggleIntegrationsModal } from '../../../redux/actions/graphapiActions';
export const diagramsDriverObj = (dispatch) => {
  const driverObj = driver({
    showProgress: true,
    nextBtnText: 'Next',
    prevBtnText: 'Previous',
    doneBtnText: 'Done',
    popoverClass: 'driverjs-theme',
    steps: [
      {
        element: '.addDiagram',
        popover: {
          title: 'Add New Diagram',
          description:
            'Click here to add a new diagram. Diagrams help visualize processes, workflows, or structures, making them easier to understand and manage.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.allDiagrams',
        popover: {
          title: 'View All Diagrams',
          description:
            'This section displays all existing diagrams. You can filter, sort, and manage diagrams to find the one you need quickly.',
          side: 'top',
          align: 'end',
          onNextClick: () => {
            dispatch(toggleIntegrationsModal());
            driverObj.destroy();
          },
        },
      },
    ],
  });
  return driverObj;
};
export default diagramsDriverObj;
